import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { MyPage } from "./pages/MyPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AllAccountPage } from "./pages/AllAccountPage";
import { GroupPage } from "./pages/GroupPage";
import { OptionPage } from "./pages/OptionPage";
import { AllMailPage } from "./pages/AllMailPage";
import { WebPage } from "./pages/WebPage";
import { MtaPage } from "./pages/MtaPage";
import { Pop3Page } from "./pages/Pop3Page";
import { ImapPage } from "./pages/ImapPage";
import { BackupPage } from "./pages/BackupPage";
import { RestorePage } from "./pages/RestorePage";
import { ChartPage } from "./pages/ChartPage";
import { SecurityPage } from "./pages/SecurityPage";
import { InMailPage } from "./pages/InMailPage";
import { OutMailPage } from "./pages/OutMailPage";
import { TrashMailPage } from "./pages/TrashMailPage";

import { InOutsHistoryPage } from "./pages/InOutsHistoryPage";
import { DevicePage } from "./pages/DevicePage";
import { DoorPage } from "./pages/DoorPage";
import { InOutAuthPage } from "./pages/InOutAccessPage";
import { InOutsPage } from "./pages/InOutsPage";

const GoogleMaterialPage = lazy(() =>
  import("./modules/GoogleMaterialExamples/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
  import("./modules/ReactBootstrapExamples/ReactBootstrapPage")
);
const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);
const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/allAccount" component={AllAccountPage} />
        <ContentRoute path="/group" component={GroupPage} />

        
        <ContentRoute path="/option" component={OptionPage} />
        <ContentRoute path="/allMail" component={AllMailPage} />

        <ContentRoute path="/web" component={WebPage} />
        <ContentRoute path="/mta" component={MtaPage} />
        <ContentRoute path="/pop3" component={Pop3Page} />
        <ContentRoute path="/imap" component={ImapPage} />
        
        <ContentRoute path="/backup" component={BackupPage} />
        <ContentRoute path="/restore" component={RestorePage} />

        <ContentRoute path="/chart" component={ChartPage} />
        <ContentRoute path="/security" component={SecurityPage} />


        <ContentRoute path="/inMail" component={InMailPage} />
        <ContentRoute path="/outMail" component={OutMailPage} />
        <ContentRoute path="/trashMail" component={TrashMailPage} />

        <ContentRoute path="/defaultconfig" component={DashboardPage} />
        <ContentRoute path="/depts" component={DashboardPage} />
        <ContentRoute path="/positions" component={DashboardPage} />
        <ContentRoute path="/inout-type" component={DashboardPage} />

        <ContentRoute path="/inouts" component={InOutsPage} />
        <ContentRoute path="/devices" component={DevicePage} />
        <ContentRoute path="/doors" component={DoorPage} />
        <ContentRoute path="/inout-auth" component={InOutAuthPage} />
        <ContentRoute path="/history-inout" component={InOutsHistoryPage} />

        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/my-page" component={MyPage} />
        <Route path="/google-material" component={GoogleMaterialPage} />
        <Route path="/react-bootstrap" component={ReactBootstrapPage} />
        <Route path="/e-commerce" component={ECommercePage} />
        <Route path="/user-profile" component={UserProfilepage} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
